"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdersPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const orders_1 = require("../../sections/orders");
const OrdersContext_1 = require("../../sections/orders/context/OrdersContext");
const OrdersPage = () => {
    return ((0, jsx_runtime_1.jsx)(OrdersContext_1.OrdersProvider, { children: (0, jsx_runtime_1.jsx)(orders_1.Orders, {}) }));
};
exports.OrdersPage = OrdersPage;
